var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Hierarchy50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M36 13L36 9 22 9 22 22 13 22 13 26 22 26 22 39 36 39 36 35 26 35 26 26 36 26 36 22 26 22 26 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D81B60",
    d: "M6 17H16V31H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M32 6H42V16H32zM32 32H42V42H32zM32 19H42V29H32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Hierarchy50);
export default __webpack_public_path__ + "static/media/icons8-hierarchy-50.12a47e4bc124545ee0d52f49d4a644a5.svg";
export { ForwardRef as ReactComponent };